import request, { uploadFile } from "../utils/request";

// 获取主板模块列表
export async function getMainModuleList() {
  const res = await request({
    url: "/department/main_list",
    method: "get",
  });
  return res;
}

// 获取子模块列表
export async function getChildModuleList(params) {
  const res = await request({
    url: "/department/second_list",
    method: "get",
    params,
  });

  return res;
}

// 获取板块下的角色
export async function getRoleList(params) {
  const res = await request({
    url: "/department/job_list",
    method: "get",
    params,
  });

  return res;
}

export async function uploadfile(params) {
  const res = await uploadFile(params);

  return res;
}
